import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";

const create = (data: CreateEmailTemplateRequest): AxiosPromise => {
  return api.post(endpoints.EMAIL_TEMPLATES.CREATE(), data);
};

const update = (emailTemplateId: number, data: CreateEmailTemplateRequest): AxiosPromise => {
  return api.put(endpoints.EMAIL_TEMPLATES.UPDATE(emailTemplateId), data);
};

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string = "",
  orderBy: string = "",
): AxiosPromise<BaseApiPaging<EmailTemplateApi>> => {
  return api.get<BaseApiPaging<EmailTemplateApi>>(
    endpoints.EMAIL_TEMPLATES.GET(skip, take, searchPhrase, filter, orderBy),
  );
};

const duplicate = (id: number): AxiosPromise<EmailTemplateApi> => {
  return api.post<EmailTemplateApi>(endpoints.EMAIL_TEMPLATES.DUPLICATE(id));
};
const fetchById = (id: number): AxiosPromise<EmailTemplateApi> => {
  return api.get<EmailTemplateApi>(endpoints.EMAIL_TEMPLATES.GET_BY_ID(id));
};
const deleteTemplate = (id: number): Promise<void> => {
  return api.delete(endpoints.EMAIL_TEMPLATES.DELETE(id));
};
const fetchTriggers = (): AxiosPromise<EmailTriggerApi[]> => {
  return api.get<EmailTriggerApi[]>(endpoints.EMAIL_TEMPLATES.GET_TRIGGERS());
};

export const emailtemplatesApi = {
  create,
  fetch,
  fetchById,
  duplicate,
  update,
  delete: deleteTemplate,
  fetchTriggers,
};

export type CreateEmailTemplateRequest = {
  name: string;
  type: number;
  subject: string;
  delay: number;
  htmlBody: string;
  isActive?: boolean;
  jsonBody: string;
  categories: number[];
};
export interface EmailTemplateApi {
  id: number;
  isActive: boolean;
  name: string;
  subject: string;
  htmlBody: string;
  jsonBody: string;
  type: number;
  delay: number;
  createdDate: Date;
  categories: number[];
}

export interface EmailTriggerApi {
  id: number;
  name: string;
  type: number;
  templates: EmailTemplateApi[];
}
